import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { Rating } from 'react-simple-star-rating';
import ClientOnly from '@/components/ClientOnly';
import ModalHoc from '@/components/ModalHoc'; // import Button from '@/components/Button';

import modalStyles from '@/components/ModalHoc/styles.module.scss';
import questionModalStyles from '@/components/ModalHoc/stylesQuestion.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ReviewsModal = _ref => {
  let {
    reviews
    /*, cta, onAdd*/

  } = _ref;
  // const hasAction = typeof onAdd === 'function' && Boolean(cta);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(questionModalStyles.container, '-pb-large'),
    children: [/*#__PURE__*/_jsx("header", {
      className: questionModalStyles.container__header,
      children: /*#__PURE__*/_jsx("h5", {
        className: questionModalStyles.heading,
        children: "Reviews"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: questionModalStyles.container__main,
      children: /*#__PURE__*/_jsx("ul", {
        className: styles.list,
        children: reviews.map((review, i) => {
          const {
            authorTitle,
            companyName,
            authorName,
            avatarUrl,
            quote,
            companyUrl
          } = review;
          return /*#__PURE__*/_jsxs("li", {
            className: styles.item,
            children: [/*#__PURE__*/_jsx("img", {
              src: avatarUrl,
              className: styles.avatar,
              loading: "lazy",
              width: 150,
              height: 150
            }), /*#__PURE__*/_jsxs("blockquote", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("p", {
                className: styles.quote,
                children: quote
              }), /*#__PURE__*/_jsx(ClientOnly, {
                children: /*#__PURE__*/_jsx("div", {
                  className: styles.score,
                  children: /*#__PURE__*/_jsx(Rating, {
                    size: 20,
                    readonly: true,
                    allowFraction: true,
                    initialValue: review.score || 0
                  })
                })
              }), /*#__PURE__*/_jsxs("footer", {
                children: [/*#__PURE__*/_jsxs("span", {
                  className: styles.credit,
                  children: [authorName, authorTitle || companyName ? ', ' : '']
                }), ' ', authorTitle && /*#__PURE__*/_jsxs(ConditionalLink, {
                  href: !companyName ? companyUrl : '',
                  children: [authorTitle, companyName ? ' - ' : '']
                }), ' ', companyName && /*#__PURE__*/_jsx(ConditionalLink, {
                  href: companyUrl,
                  children: companyName
                })]
              })]
            })]
          }, `review-${i}`);
        })
      })
    })]
  });
};

export default ModalHoc(ReviewsModal, {
  indexable: true,
  overlayclass: modalStyles['overlay--high']
});

const ConditionalLink = _ref2 => {
  let {
    href,
    title,
    children
  } = _ref2;

  if (href) {
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      href: href,
      target: "_blank",
      rel: "external nofollow noopener noreferrer",
      className: styles.creditDetail
    }, title && {
      title
    }), {}, {
      children: children
    }));
  }

  return /*#__PURE__*/_jsx("span", {
    className: styles.creditDetail,
    children: children
  });
};